import { Trans } from "react-i18next";
import { ProductEditorBody } from "./ProductEditorBody";
import type { ProductFormState, ProductImageFile, SellingPointItem } from "./types";
import type { SellingPointsStatus } from "./useProductForm";

export interface ProductEditorProps {
  form: ProductFormState;
  imageFiles: ProductImageFile[];
  sellingPointsStatus: SellingPointsStatus;
  showRefresh: boolean;
  onChangeForm: (patch: Partial<ProductFormState>) => void;
  onFilesChange: (files: ProductImageFile[]) => void;
  uploadFile: (file: File, ctx: any) => Promise<any>;
  onChangeCaption: (uid: string, caption: string) => void;
  onChangeSellingPoints: (items: SellingPointItem[]) => void;
  onAddSellingPoint: (content: string) => void;
  onRemoveSellingPoint: (id: string) => void;
  onRefreshSellingPoints?: () => void;
}

/**
 * Create Product Entity Modal 的主编辑表单（Banner 提示 + ProductEditorBody）。
 *
 * 设计稿节点：3433:23458（720x684 modal）。
 *
 * 结构：
 * 1. Banner（-mx-[16px] 拉满，bg-kds-bg-subtle）
 * 2. ProductEditorBody — 图片 + Name + Category + SellingPoints
 *
 * 底栏（Cancel + AI Analyze | Save）由 index.tsx 通过 ClipModal 的 footerConfig 渲染。
 */
export const ProductEditor = ({
  form,
  imageFiles,
  sellingPointsStatus,
  showRefresh,
  onChangeForm,
  onFilesChange,
  uploadFile,
  onChangeCaption,
  onChangeSellingPoints,
  onAddSellingPoint,
  onRemoveSellingPoint,
  onRefreshSellingPoints,
}: ProductEditorProps) => {
  return (
    <div className="flex flex-col">
      <div className="-mx-[16px] -mt-[8px] mb-[16px] bg-kds-bg-subtle px-[16px] pt-[12px] pb-[10px]">
        <p className="m-0 text-[14px] leading-[1.4] text-kds-fg-soft">
          <Trans>
            Upload multi-angle photos of a single SKU (style/color). Avoid mixing different variants, and exclude images
            with excessive text, accessories (e.g., replacement brush heads), or group shots (e.g., product sets).
          </Trans>
        </p>
      </div>

      <ProductEditorBody
        form={form}
        imageFiles={imageFiles}
        sellingPointsStatus={sellingPointsStatus}
        showRefreshSellingPoints={showRefresh}
        variant="modal"
        onChangeForm={onChangeForm}
        onFilesChange={onFilesChange}
        uploadFile={uploadFile}
        onChangeCaption={onChangeCaption}
        onChangeSellingPoints={onChangeSellingPoints}
        onAddSellingPoint={onAddSellingPoint}
        onRemoveSellingPoint={onRemoveSellingPoint}
        onRefreshSellingPoints={onRefreshSellingPoints}
      />
    </div>
  );
};
